import { render, staticRenderFns } from "./addTransfer.vue?vue&type=template&id=ed96c5ca&scoped=true&"
import script from "./addTransfer.vue?vue&type=script&lang=js&"
export * from "./addTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed96c5ca",
  null
  
)

export default component.exports